import { gql } from '@apollo/client';

const PoolSummaryFragments = {
  performanceSummary: gql`
    fragment PoolSummaryPerformanceSummary on PerformanceSummary {
      unpaidBalance: current_balance_cents
      originalBalance: original_balance_cents
      loanCount: loan_count
      averageBalance: wa_current_balance_cents
      averageOriginalBalance: wa_original_balance_cents
      netCoupon: wa_coupon_bps
      averageAge: wa_age_months
      averageMaturity: wa_remaining_loan_terms_months
      fico: wa_borrower_credit_score
      dti: wa_dti_bps
      ltv: wa_ltv_bps
      minDscr: min_dscr_bps
      maxDscr: max_dscr_bps
      avgDscr: wa_dscr_bps
      dscrCount: t_dscr
      nonQmCount: t_non_qm
      dscrPct: pct_dscr
      nonQmPct: pct_non_qm
      assetUtilCount: t_asset_util
      assetUtilPct: pct_asset_util
      states: strat_state {
        stateCode: key
        loanCount: t_count
      }
    }
  `,
};

export { PoolSummaryFragments };
